import React from 'react';

const SocialLoginButton = ({ onClick, iconSrc, label }) => (
  <div className='form-group'>
    <a onClick={onClick} className='signin-btn'>
      <span className='signin-iconbtn'>
        <img src={iconSrc} alt='Image not present' />
      </span>{' '}
      {label}
    </a>
  </div>
);

export default SocialLoginButton;
